import React from "react";
import "./index.css";

interface ToggleOption {
  label: string;
  value: string;
}

interface ToggleButtonGroupProps {
  options: ToggleOption[];
  selectedValue: string | null;
  onChange: (value: string | null) => void;
  disabled: boolean;
}

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
  options,
  selectedValue,
  onChange,
  disabled,
}) => {
  const handleClick = (optionValue: string) => {
    onChange(selectedValue === optionValue ? null : optionValue);
  };

  return (
    <div className="toggle-group__buttons">
      {options.map((option, index) => (
        <React.Fragment key={option.value}>
          <button
            type="button"
            onClick={() => handleClick(option.value)}
            className={`toggle-group__btn${selectedValue === option.value ? " toggle-group__btn--selected" : ""}`}
            disabled={disabled}
          >
            {option.label}
          </button>
          <div className="toggle-group__separator"></div>
        </React.Fragment>
      ))}
    </div>
  );
};
